export var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
export var uid = function uid() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 32;
  return Array.from(Array(length)).reduce(function (res) {
    return res + chars[Math.floor(Math.random() * chars.length)];
  }, '');
};